export default data => {
  if (data && typeof data === 'string') {
    return {
      placeholder: i18n(data)
    }
  }
  if (Array.isArray(data) && data.length === 2) {
    return {
      startPlaceholder: i18n(data[0]),
      endPlaceholder: i18n(data[1])
    }
  }
  return {}
}



// WEBPACK FOOTER //
// ./packages/utils/parsePlaceholder.js